import {
  Directive, ViewContainerRef, ComponentRef, Type, ComponentFactory, ComponentFactoryResolver, ChangeDetectorRef
} from '@angular/core';

import { ModalStepInputType } from 'models/multimodal.model';

@Directive({
  selector: '[appDynamicInsertion]'
})
export class DynamicInsertionDirective {
  constructor(
    private cd: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef
  ) { }

  loadChildComponent(componentType: Type<any>, data: ModalStepInputType): ComponentRef<any> {
    const componentFactory: ComponentFactory<any> = this.componentFactoryResolver.resolveComponentFactory(
      componentType
    );

    const viewContainerRef: ViewContainerRef = this.viewContainerRef;
    viewContainerRef.clear();

    const componentRef: ComponentRef<any> = viewContainerRef.createComponent(componentFactory);
    if (data) {
      componentRef.instance.data = data;
    }
    this.cd.detectChanges();

    return componentRef;
  }
}
